<template>
  <div>
    <h1 class="sec-title">客户跟进规则设置</h1>
    <div class="clearfix rule-con mt15">
      <p class="desc floatL"><b>客户跟进规则</b>：</p>
      <div class="desc floatL">
        <el-radio-group v-model="task_flow_status">
          <el-radio :label="2">
            <span class="checkbox-label">禁用</span>
          </el-radio>
          <el-radio :label="1">
            <span class="checkbox-label">启用</span>
          </el-radio>
        </el-radio-group>
        <el-popover placement="top-start" trigger="hover">
          <div class="popover-info">
            <p>设置客户跟进规则之后，生效范围为全部客户，系统会自动给员工生成相应的待办任务</p>
          </div>
          <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
        </el-popover>
      </div>
    </div>
    <!-- 跟进规则 -->
    <div class="system-setting-task-follow" v-if="task_flow_status === 1">
      <div class="items">
        <i class="follow-round"></i>
        <p class="follow-line"></p>
        <el-button icon="el-icon-plus" type="primary" size="small" plain @click="openRuleSetting(null, 'new')">
          添加规则
        </el-button>
      </div>
      <div class="items" v-for="(item, i) in hadFollowRuleList" :key="i">
        <i class="follow-round active"></i>
        <p class="follow-line"></p>
        <h1 class="name">{{item.title}}</h1>
        <div class="cons">
          <p class="flollow-desc">当客户在<span>【{{item.name}}】</span>后<span>{{item.value}}</span>天后需要再次跟进</p>
          <el-button type="primary" size="mini" @click="openRuleSetting(item, 'edit')">编辑</el-button>
          <el-button type="danger" size="mini" @click="removeFollowRulePress(item, i)">删除</el-button>
        </div>
      </div>
    </div>
    <div class="mt15 save-btn-con" v-if="showSave">
      <p class="saveTips">保存更改后即时生效，请谨慎操作哦！</p>
      <el-button size="small" class="save-btn global-btn primary" @click="handleSave">保存</el-button>
    </div>
    <operate-follow-rule ref="bussFollowDetail" @callback="initBatchRule"/>
  </div>
</template>
<script>
import OperateFollowRule from './component/operateFollowRule';
import {getFollowRuleBatch, removeFollowRule, getSystemCustomeFollow, setSystemCustomeFollow} from '@/api/system';
export default{
  name: 'customeFollow',
  components: {OperateFollowRule},
  props: {
    info: Object
  },
  watch: {
      task_flow_status: {
          handler (newVal, oldVal){
              this.showSave = this.ruleData.task_flow_status !== newVal;
          }
      }
  },
  data () {
    return {
      task_flow_status: 0,
      followRuleList: ['task_in_private', 'task_voucher_6', 'task_voucher_7', 'task_voucher_8', 'task_voucher_9', 'task_voucher_10', 'task_voucher_11', 'task_voucher_12'],
      hadFollowRuleList: [],
      showSave: false,
      ruleData:{},
      sourceArr:[]
    }
  },
  created() {
    this.initList();
    this.initBatchRule();
  },
  methods: {
    async initList () {
      try {
        const res = await getSystemCustomeFollow();
        this.ruleData = res;
        this.task_flow_status = res.task_flow_status;
      } catch (error) {
        this.$message.error('操作失败，请重试');
      }
    },
    async initBatchRule () {
      try {
        const res = await getFollowRuleBatch();
        this.followRuleList = Object.keys(res);
        const followList = [];
        this.followRuleList.map(v => {
          if (res[v]) followList.push({
            ...res[v],
            type: v
          });
        });
        this.hadFollowRuleList = followList;
        this.sourceArr = JSON.parse(JSON.stringify(followList));
      } catch (error) {
        this.$message.error('操作失败，请重试');
      }
    },
    // 打开跟进规则
    openRuleSetting (data, type) {
      this.$refs.bussFollowDetail && this.$refs.bussFollowDetail.open(data, type, this.hadFollowRuleList);
    },
    // 移除某个跟进规则
    removeFollowRulePress (row, index) {
      this.$confirm('确认删除该客户跟进规则？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          await removeFollowRule({
            type: row.type
          });
          this.$message.success('删除成功');
          // 删除当前行
          this.hadFollowRuleList.splice(index, 1);
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    },
    async handleSave () {
      try {
        await setSystemCustomeFollow({
          task_flow_status: this.task_flow_status
        });
        this.$message.success('保存成功');
      } catch (error) {
        this.$message.error('操作失败，请重试');
      }
    }
  },
}
</script>
<style scoped>
.save-btn-con{
  margin-top: 35px;
}
.saveTips{
  color: #999999;
  font-size: 12px;
  margin-bottom: 15px;
}
</style>
